import {
  faPencilAlt,
  faTimes,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import classNames from 'classnames';
import Button from 'components/base/Button';
import NutritionTable, {
  nutritionTableColumns
} from 'components/tables/NutritionTable';
import dayjs from 'dayjs';
import { errorHandler } from 'helpers/response-utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useCalendarContext } from 'providers/CalendarProvider';
import { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { REMOVE_EVENT, SET_CALENDAR_STATE } from 'reducers/CalendarReducer';
import FoodPaichart from './FoodPaichart';
import moment from 'moment';

// Define types
type NutritionFact = {
  nutrientName: string;
  value: number;
  unitName: string;
};

type Nutrient = {
  name: string;
  nutritionFact: NutritionFact[];
  quantity: string;
  servingSize: number;
  servingSizeUnit: string;
};

type DataItem = {
  extendedProps: {
    createdAt: number;
    mealFile: string;
    notes: string;
    nutrient: Nutrient[];
  };
};

const CalendarFullDatEventModal = ({
  selectedDate,
  handleCloseFullDayEventModal
}: {
  selectedDate: any;
  handleCloseFullDayEventModal: any;
}) => {
  const { id } = useParams();
  const token = localStorage.getItem('token');
  const [currentDayMeals, setCurrentDayMeals] = useState<DataItem[]>([]);

  useEffect(() => {
    if (selectedDate != '') {
      getMealByDateRange();
    }
  }, [selectedDate]);

  const getMealByDateRange = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/clinic/meal/getall`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            startDate: moment(selectedDate).format('YYYY-MM-DD'),
            endDate: moment(selectedDate).format('YYYY-MM-DD'),
            patient: id
          }
        }
      );

      if (response.data.status === false) {
        errorHandler(response.data);
        return;
      }
      const data = response.data.data.meals;
      const nutrientFact = response.data.data.meals
        .map((item: any) => item.extendedProps.nutrient)
        .flat();
      setCurrentDayMeals(nutrientFact);
    } catch (error) {
      console.error('Error occurred:', error);
    }
  };

  const color = ['#ED4D18', '#1ACEDA', '#FEB91A', '#4E7CB6', '#A1A1A1'];
  return (
    <>
      <Modal
        centered
        show={selectedDate != ''}
        onHide={handleCloseFullDayEventModal}
        contentClassName="border"
        size="lg"
      >
        <Modal.Body className="px-card pb-card pt-1 fs-9">
          <Row>
            <Col
              className="m-3"
              style={{
                background: '#e8e8e8',
                padding: '10px',
                borderRadius: '10px'
              }}
            >
              <Modal.Title
                className="modal-title text-body-highlight mb-0"
                style={{ display: 'inline' }}
              >
                Summary {moment(selectedDate).format('DD-MM-YYYY')}
              </Modal.Title>
              <Button
                className="p-1"
                style={{ float: 'right' }}
                onClick={handleCloseFullDayEventModal}
              >
                <FontAwesomeIcon icon={faTimes} className="fs-8" />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12}>
              {currentDayMeals.length ? (
                <FoodPaichart nutrient={currentDayMeals} />
              ) : (
                <p>No Record found!</p>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CalendarFullDatEventModal;
